export default __webpack_public_path__ + "static/media/BgSignUp.2dea4acf.png";